import React from 'react';
import { AnimatedCollapse } from '@/components/ui/animated-collapse';
import { MealHourlyPremiumOTSplit } from '@/components/config_forms/shared/help-graphics/MealHourlyPremiumOTSplit';

export interface MealHourlyPremiumOTInteractionProps {
  premiumType: 'fixed' | 'percentage';
  premiumValue: number;
  premiumBasis: 'base_rate' | 'ot_inclusive';
  recurringDeadline: boolean;
  ladder: Array<{
    code: string;
    name: string;
    multiplier: number;
    thresholdHours: number | null;
  }>;
}

export const MealHourlyPremiumOTInteraction: React.FC<MealHourlyPremiumOTInteractionProps> = ({
  premiumType,
  premiumValue,
  premiumBasis,
  recurringDeadline,
  ladder,
}) => {
  const showOvertimeInteraction = premiumBasis === 'ot_inclusive';

  // Keep the split markup mounted across basis toggles so AnimatedCollapse
  // can play a smooth height transition when closing. Pair the
  // visual-only AnimatedCollapse with an inert aria-hidden wrapper while
  // collapsed so SR users don't hear stale content.
  return (
    <div
      data-anim-audit="hourly-premium-ot-interaction"
      data-anim-audit-open={showOvertimeInteraction ? 'true' : 'false'}
      aria-hidden={showOvertimeInteraction ? undefined : 'true'}
    >
      <AnimatedCollapse open={showOvertimeInteraction} duration={350}>
        <div className="mt-1">
          <h3 className="text-base font-bold text-primary-text mb-2">Overtime Interaction</h3>
          <p>
            When a surcharge period spans an overtime rate change (e.g., straight time into overtime),
            each portion is valued at the rate in effect during that time.
          </p>

          {/* Force 'ot_inclusive' on the split so its DOM stays mounted
              across basis toggles — the outer AnimatedCollapse hides it
              visually when the real basis is 'base_rate'. This keeps the
              close animation smooth without unmount flicker. */}
          <MealHourlyPremiumOTSplit
            premiumType={premiumType}
            premiumValue={premiumValue}
            premiumBasis="ot_inclusive"
            ladder={ladder}
          />

          {recurringDeadline && (
            <p className="mt-2">
              When recurring deadline is enabled and multiple violations stack, each one follows the same mechanic.
            </p>
          )}
        </div>
      </AnimatedCollapse>
    </div>
  );
};
